import React from 'react'
import { Link } from 'react-router-dom'
import { Table } from 'react-bootstrap';
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'




function Main() {

    return (
        <>

            <Header />
            <Breadcrumb title="Home" subtitle="Alumni Center" />

            <section className="team-area fix p-relative pt-120 pb-80">
                 
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 p-relative">
                            <div className="section-title center-align mb-50 text-center wow fadeInDown animated" data-animation="fadeInDown" data-delay=".4s">
                                <h5>
                                    {/* <i className="fal fa-graduation-cap" /> Research Scholars */}
                                </h5>
                                <h3>Office of Global Engagement, Alumni and Corporate Relations - Alumni Center</h3>
                            </div>
                        </div>
                        <p className='mb-3 line c-lineheight2'>We are delighted to announce that IIT Tirupati has recently secured membership with both the following alumni centers. </p>
                       

                       
                        <div className=''>

                            <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />IIT Alumni Industry Interaction Center (IIT AICC) in the IIT Madras Research Park, Chennai - <Link className="c-link" to="https://iitalumnicenter.org/" target="_blank">Click here</Link><br /></li>
                            <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />IIT Alumni Center Bangalore (IIT ACB) - <Link className="c-link" to="https://iitacb.org/" target="_blank">Click here</Link><br /></li>
                            
                        </div>
                        <p></p>
                        <p className='mb-3 line c-lineheight2'>These centers are aimed at fostering industry, academia, and alumni interactions leveraging on the strong alumni and industry presence in these locations. Both the centers allow our faculty to use their facilities for conducting workshops/seminars/meetings/conferences etc. for a nominal charge, based on our needs and the target audience.</p>
                        <p className='mb-3 line c-lineheight2'>In addition, IIT AICC (Chennai) provides us a platform to network with industries in Chennai and in the IITM research park in particular. It also has a few guest rooms for overnight stays in Chennai. </p>
                        <p className='mb-3 line c-lineheight2'>On the other hand, IIT ACB (Bengaluru) allows us to plug into the startup ecosystem in Bengaluru. We may also be able to secure a desk/small office space for startups/incubated companies within their facility based on the availability.</p>
                        <p className='mb-3 line c-lineheight2'>We encourage you to explore the potential of these centers using the above links, and take full advantage of the resources they offer whenever you are in these cities. The present tariffs for the facilities at both these centers are given below. </p>
                        <div className='mt-3 line c-lineheight3'>
                            <h5>IIT AICC (Chennai) Tariffs : <Link className="c-link" to="https://files.iittp.ac.in/pdfs/oia/IITM_WL.pdf" target="_blank">View</Link><br /></h5>
                            <h5>IIT ACB (Bengaluru) Tariffs : <Link className="c-link" to="https://files.iittp.ac.in/pdfs/oia/IITACB.pdf" target="_blank">View</Link><br /></h5>

                        </div>

                    </div>
                    
                </div>
            </section>
        </>
    )
}

// // Function to parse HTML content and extract text
// function parseHTML(htmlString) {
//     const tempElement = document.createElement('div');
//     tempElement.innerHTML = htmlString;
//     return tempElement.textContent || tempElement.innerHTML || '';
// }


export default Main